import appConstants from '../appConstants';

//Now using static region Chicago - 48104
//Now using static location Linkoln park - 48022 
//TODO get choosenRegion from previous steps
//https://fhittingroom2.sandbox.marianatek.com/api/customer/v1/regions/48543/schedule_filters
//https://fhittingroom2.sandbox.marianatek.com/api/customer/v1/classes?min_start_date=2021-11-15&max_start_date=2021-11-15&page_size=500&location=48104&region=48022


// for BUY PAGES LINK
// https://fhittingroom.marianatek.com/api/customer/v1/locations/48104/buy-page

// should be refactored  
//dont needed in store

let mapGetters = Vuex.mapGetters;
let mapActions = Vuex.mapActions;

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': 'Bearer vFG6SuCslf3lXXf0eLU2zeSrLSCUDm'
};


export default {
    template: '#studio-component',
    delimiters: ['${', '}'],
    data() {
        return {
            instructors: [],
            typeOfClasses: [],
            dates: [],
            classes: [],
            classesLoader: false,
            location: 48104,
            region: 48022,
            minDate: null,
            maxDate: null,
            filters: {
                instructors: [],
                types: []
            },
            firstDayOfWeek: null,
            dateNow: null,
            choosenDate: null,
            choosenDateFull: null,
            classesLoading: true,
            checkedWeek: false,
            currentWeek: true,
            currentStep: 1,
            // STEP2
            classDetails: null,
            //STEP3
            selectedSpotIndex: null,
            //STEP4
            packageTypes: null,
            selectedPackage: null,
            isShowPackagePopup: false,
            selectedPackageActive: null,
            packageFeatures: null,
            cartSubTotal: 0,
            // STEP 5
            cartData: null
        };
    },
    created() {
        window.scrollTo(0, 0);
        //init base date

        this.maxDate = moment(new Date()).format('YYYY-MM-DD');
        this.minDate = moment(new Date()).format('YYYY-MM-DD');
        this.dateNow = moment(Date.now());

        this.initializeTopPart();


        this.getData({
            url: this.todayClassesUrl
        })
            .then((result) => {
                this.classes = [...result.results];
                this.classesLoading = false;
                return this.getData(appConstants.DATA_CHOOSEN_REGION);
            })
            .then((result) => {
                this.instructors = [...result.instructors];
                this.typeOfClasses = [...result.class_types];
                jcf.getInstance($(".instructors_filter")).refresh();
                jcf.getInstance($(".types")).refresh();
            });

        // STEP 4 GET PACKAGES
        this.getData({url: 'https://demo-n9c5fm.marianatek.com/api/customer/v1/locations/48070/buy-page'})
            .then(data => {
                this.packageTypes = data;
            })


        // STEP 5 GET CART DATA
        this.getData({url: 'https://demo-n9c5fm.marianatek.com/api/customer/v1/locations/48070/cart', headers})
            .then(data => {
                this.cartData = data;
            })
    },
    computed: {
        ...mapGetters([
            'getRegions',
            'getLocations'
        ]),
        typeOfClassesToSelect() {
            return this.typeOfClasses.length ? this.typeOfClasses.map((typeOfClass) => {
                return typeOfClass.name;
            }) : [];
        },
        instructorsToSelect() {
            return this.instructors.length ? this.instructors.map((instructor) => {
                return instructor.name;
            }) : [];
        },
        todayClassesUrl() {
            return `${appConstants.DOMAIN}/api/customer/v1/classes?min_start_date=${this.minDate}&max_start_date=${this.maxDate}&page_size=500&location=${this.location}&region=${this.region}`;
        },
        filteredClasses() {
            let filteredValue = this.classes;
            //TODO: i think would be great to choose more than one instructor/type to filter
            //filter by instructor name
            filteredValue = this.filters.instructors.length ?
                filteredValue.filter((choosenClass) => this.filters.instructors.includes(choosenClass.instructors[0].name)) :
                filteredValue;
            //filter by type of classes
            filteredValue = this.filters.types.length ?
                filteredValue.filter((type) => this.filters.types.includes(type.class_type.name)) :
                filteredValue;
            return filteredValue && filteredValue.length ? filteredValue.map(item => {
                return {
                    ...item,
                    past: this.dateNow.diff(moment(this.choosenDateFull), 'days') > 0 || false,
                };
            }) : [];
        },
        calendarTitle() {
            let choosenDay = this.dates ? this.dates.find(day => day.choosen) : '';
            return choosenDay ? `${choosenDay.weekday} ${choosenDay.month} ${choosenDay.day}TH` : '';
        },
    },
    methods: {
        ...mapActions([
            'downloadData',
            'getData',
            'updateChosenInstructor',
        ]),
        clearFilters() {
            this.$refs.instructorFilter.selectDefault();
            this.$refs.typesFilter.selectDefault();
            this.filters.instructors = [];
            this.filters.types = [];
        },
        getChoosenClasses() {
            let choosenDay = this.dates ? this.dates.find(day => day.choosen) : '';
            this.maxDate = moment(choosenDay.date).format('YYYY-MM-DD');
            this.minDate = moment(choosenDay.date).format('YYYY-MM-DD');
            this.classesLoading = true;
            this.getData({
                url: this.todayClassesUrl
            })
                .then((result) => {
                    console.log(result);
                    this.classes = [...result.results];
                    this.classesLoading = false;
                });
        },
        initializeTopPart() {
            const firstday = new Date(moment().startOf('isoweek'));
            this.choosenDateFull = new Date(Date.now());
            this.choosenDate = new Date(Date.now()).getDate();
            this.firstDayOfWeek = firstday;
            this.dates = [...this.getAllWeek(firstday)];
        },
        calculateDate(next) {
            let addedDate = next ? new Date(moment(this.firstDayOfWeek).add(7, 'days')) : new Date(moment(this.firstDayOfWeek).subtract(7, 'days'));
            this.choosenDate = addedDate.getDate();
            this.choosenDateFull = addedDate;
            this.firstDayOfWeek = addedDate;
            this.dates = [...this.getAllWeek(addedDate)];
            //pick moday as choosen
            this.chooseDate(this.dates.find(day => day.choosen));
        },
        reserveInstructor(instructor, toNextStep) {
            window.scrollTo(0, 0);
            //here we will reserve an instructor
            this.updateChosenInstructor(instructor);
            //this request will be done after redirect on the next page
            //also we can get spot from this request if we have it
            this.getData({url: `${appConstants.CHOOSEN_INSTRUCTOR_INFO}${instructor.id}`})
                .then((result) => {
                    console.log('result', result);
                    this.classDetails = result;
                });
            this.currentStep = toNextStep;
        },
        getAllWeek(firstDay) {
            //TODO can be refactored
            //1.create mixin for working with calendar
            let arr = [];
            let day = new Date(firstDay);
            for (let i = 0; i < 7; i++) {
                arr.push({
                    day: day.getDate(),
                    month: day.toLocaleDateString('en-GB', {
                        month: 'long'
                    }),
                    weekday: day.toLocaleDateString('en-GB', {
                        weekday: 'long'
                    }),
                    date: day,
                    choosen: this.choosenDate === day.getDate() || false,
                });
                day = new Date(moment(day).add(1, 'day'));
            }
            ;
            return arr;
        },
        chooseDate(choosenDate) {
            this.choosenDateFull = choosenDate.date;
            this.dates = [...this.dates.map(date => {
                return {
                    ...date,
                    choosen: date.day === choosenDate.day || false
                };
            })];
            this.getChoosenClasses();
        },
        changeWeek() {
            this.currentWeek = !this.currentWeek;
            this.currentWeek ? this.initializeTopPart() : null;
            // should be refactored (duplicated logic)
            if (!this.currentWeek) {
                const firstday = new Date(moment().startOf('isoweek'));
                let addedDate = new Date(moment(firstday).add(7, 'days'))
                this.choosenDate = addedDate.getDate();
                this.choosenDateFull = addedDate;
                this.firstDayOfWeek = addedDate;
                this.dates = [...this.getAllWeek(addedDate)];
            }
            this.chooseDate(this.dates.find(day => day.choosen));
        },
        filterByInstructor() {
            this.filters.instructors = []
            this.filters.instructors.push(this.$refs.instructorFilter.selected);
        },
        filterByType() {
            this.filters.types = []
            this.filters.types.push(this.$refs.typesFilter.selected);
        },
        convertDate(date) {
            return moment(date).format('dddd, ll');
        },
        convertTime(time) {
            return time.slice(0, time.length - 3);
        },
        convertPrice(price) {
            return Number.isInteger(price) ? price.toFixed(2) : price
        },
        //STEP 3 (SELECT SPOT)
        selectSpot(spot, index) {
            this.selectedSpotIndex = index;
        },
        //STEP 4 (SELECT PACKAGE)
        openPackagePopup(product) {
            this.selectedPackage = product;
            this.isShowPackagePopup = true;
            this.selectedPackageActive = product.id;

            const result = [];

            const expiration = {
                name: 'Expiration Date',
                value: ''
            };

            const commitment = {
                name: 'Commitment',
                value: ''
            };

            const billingFrequency = {
                name: 'Billing Frequency',
                value: ''
            };

            const expirationMembership = {
                name: 'Expiration Date',
                value: ''
            };

            function convertDateHelper(date) {
                if (date === 'YR') {
                    date = ' Year(s)';
                }
                if (date === 'MO') {
                    date = ' Month(s)';
                }
                if (date === 'DY') {
                    date = ' Day(s)';
                }
                return date;
            }

            product.product_display_attributes.forEach(item => {

                if (item.name === 'Credit Quantity' || item.name === 'Usage Interval Limit') {
                    result.push({
                        name: 'Usages',
                        value: item.value !== null ? item.value + ' Class(es)' : 'Unlimited'
                    });
                }

                if (item.name === 'Guest Usages Allowed') {
                    result.push({
                        name: 'Guest Allowance',
                        value: item.value === 'True' ? 'Yes' : 'No'
                    });
                }

                if (item.name === 'Guest Usage Interval Limit') {
                    result.push({
                        name: 'Guest Allowance',
                        value: item.value !== null ? item.value + ' Class(es)' : 'Unlimited'
                    });
                }

                if (item.name === 'Commitment Length') {
                    commitment.value = item.value;
                }

                if (item.name === 'Expiration Interval' || item.name === 'Payment Interval') {

                    expiration.value = convertDateHelper(item.value);
                    expirationMembership.value = convertDateHelper(item.value);
                    commitment.value = commitment.value + convertDateHelper(item.value);
                    billingFrequency.value = billingFrequency.value + convertDateHelper(item.value)

                    if (commitment.value.includes('null')) {
                        commitment.value = 'No commitment';
                    }
                }

                if (item.name === 'Expiration Interval Length') {
                    expiration.value = item.value + expiration.value;
                    result.push(expiration);
                }

                if (item.name === 'Payment Interval') {
                    result.push(commitment);
                }

                if (item.name === 'Payment Interval Length') {
                    billingFrequency.value = 'Every ' + item.value + billingFrequency.value;
                    result.push(billingFrequency);
                }

                if (item.name === 'Renewal Limit') {
                    expirationMembership.value = item.value !== null ? item.value + expirationMembership.value : 'Membership will recur forever or until terminated';
                    result.push(expirationMembership);
                }
            });


            this.packageFeatures = result;
        },
        closePackagePopup() {
            this.isShowPackagePopup = false;
        },
        async addToCart(product) {
            const url = 'https://demo-n9c5fm.marianatek.com/api/customer/v1/locations/48070/cart/add_product_listing';

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({
                        "product_listing_id": product.id,
                        "quantity": 1
                    }),
                    headers: headers
                });
                this.cartData = await response.json();
            } catch (error) {
                console.error(error);
            }

            this.cartSubTotal += product.price;
            this.closePackagePopup();
        },
        async removeFromCart(product) {
            const url = 'https://demo-n9c5fm.marianatek.com/api/customer/v1/locations/48070/cart/adjust_quantity';
            try {
                const response = await fetch(url, {
                    method: 'POST',
                    body: JSON.stringify({
                        "line_item_id": product.id,
                        "quantity": 0
                    }),
                    headers: headers
                });
                this.cartData = await response.json();
            } catch (error) {
                console.error(error);
            }

            this.cartSubTotal -= product.price;
        }
    }
};


// WEBPACK FOOTER //
// ./assets/js/modules/vueComponent/studioComponent.js